import { PlusIcon } from "@heroicons/react/24/solid";
const PlusButton = ({
  onClick,
  className = "",
  disabled = false,
  type = "button",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      //  className="flex flex-row text-primary hover:bg-primary hover:text-white items-center text-xs font-medium border rounded-full transition duration-500 ease select-none focus:outline-none focus:shadow-outline"
      className={`hover:scale-90 transition duration-500 flex flex-row text-white hover:text-primary shadow-md bg-primary hover:bg-white items-center text-xs font-medium border border-primary rounded-full transition duration-500 align-middle ease select-none focus:outline-none focus:shadow-outline mr-5 ${className}`}
    >
      <PlusIcon className="h-4 w-4" />
    </button>
  );
};
export default PlusButton;
